module.exports = __webpack_public_path__ + "static/media/landing-blob.e8683438.png";